export type ZipEntry = {name: string, content: string | Uint8Array}

const crc32 = (data: Uint8Array): number => {
  let crc = 0xffffffff
  for (const byte of data) {
    crc ^= byte
    for (let bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1))
  }
  return (crc ^ 0xffffffff) >>> 0
}

const join = (parts: Uint8Array[]): Uint8Array => {
  const result = new Uint8Array(parts.reduce((size, part) => size + part.length, 0))
  let offset = 0
  for (const part of parts) { result.set(part, offset); offset += part.length }
  return result
}

export function createZip(entries: ZipEntry[]): Uint8Array {
  const encoder = new TextEncoder()
  const local: Uint8Array[] = []
  const central: Uint8Array[] = []
  let offset = 0

  for (const entry of entries) {
    const name = encoder.encode(entry.name.replaceAll("\\", "/"))
    const content = typeof entry.content === "string" ? encoder.encode(entry.content) : entry.content
    const crc = crc32(content)
    const header = new Uint8Array(30 + name.length)
    const view = new DataView(header.buffer)
    view.setUint32(0, 0x04034b50, true)
    view.setUint16(4, 20, true)
    view.setUint16(6, 0x0800, true)
    view.setUint32(14, crc, true)
    view.setUint32(18, content.length, true)
    view.setUint32(22, content.length, true)
    view.setUint16(26, name.length, true)
    header.set(name, 30)
    local.push(header, content)

    const record = new Uint8Array(46 + name.length)
    const directory = new DataView(record.buffer)
    directory.setUint32(0, 0x02014b50, true)
    directory.setUint16(4, 20, true)
    directory.setUint16(6, 20, true)
    directory.setUint16(8, 0x0800, true)
    directory.setUint32(16, crc, true)
    directory.setUint32(20, content.length, true)
    directory.setUint32(24, content.length, true)
    directory.setUint16(28, name.length, true)
    directory.setUint32(42, offset, true)
    record.set(name, 46)
    central.push(record)
    offset += header.length + content.length
  }

  const directory = join(central)
  const end = new Uint8Array(22)
  const footer = new DataView(end.buffer)
  footer.setUint32(0, 0x06054b50, true)
  footer.setUint16(8, entries.length, true)
  footer.setUint16(10, entries.length, true)
  footer.setUint32(12, directory.length, true)
  footer.setUint32(16, offset, true)
  return join([...local, directory, end])
}
